import "@/styles/globals.css";
import type { AppProps } from "next/app";
import { AuthProvider } from "@/lib/AuthContext";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export default function App({ Component, pageProps }: AppProps) {
  const router = useRouter();
  const [isBrowser, setIsBrowser] = useState(false);
  const isAdminPage = router.pathname.startsWith('/admin');

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  if (isAdminPage) {
    if (!isBrowser) {
      return <Component {...pageProps} />;
    }
    return (
      <AuthProvider>
        <Component {...pageProps} />
      </AuthProvider>
    );
  }

  return <Component {...pageProps} />;
}
